import { render, staticRenderFns } from "./Publicidad.vue?vue&type=template&id=391a70c1&scoped=true&"
import script from "./Publicidad.vue?vue&type=script&lang=js&"
export * from "./Publicidad.vue?vue&type=script&lang=js&"
import style0 from "./Publicidad.vue?vue&type=style&index=0&id=391a70c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391a70c1",
  null
  
)

export default component.exports